import axios from 'axios'
import { buildQuery } from '../exports/queryStringBuilder'

export default {
    async fetchAll(query, filters, page) {
        return await axios.get(`rpa-template?q=${query}&page=${page}&${buildQuery(filters)}`)
    },

    async fetchById(id) {
        return await axios.get(`rpa-template/${id}`)
    },

    async create(payload) {
        return await axios.post(`rpa-template`, payload)
    },

    async update(id, payload) {
        return await axios.put(`rpa-template/${id}`, payload)
    },

    async delete(id) {
        return await axios.delete(`rpa-template/${id}`)
    },

    async fetchItems(templateId) {
        return await axios.get(`rpa-template/${templateId}/items`)
    },

    async createItem(templateId, payload) {
        return await axios.post(`rpa-template/${templateId}/items`, payload)
    },

    async updateItem(templateId, itemId, payload) {
        return await axios.put(`rpa-template/${templateId}/items/${itemId}`, payload)
    },

    async deleteItem(templateId, itemId) {
        return await axios.delete(`rpa-template/${templateId}/items/${itemId}`)
    },

    async fetchItemById(templateId, itemId) {
        return await axios.get(`rpa-template/${templateId}/items/${itemId}`)
    },

    async exportExcel(query) {
        try {
            // Use the new export-excel endpoint
            return await axios.get(`rpa-template/export-excel?q=${query || ''}`)
        } catch (error) {
            console.error('Export API error:', error);
            throw error;
        }
    },

    async exportExcelAsText(query) {
        try {
            // Use the new export-excel endpoint
            return await axios.get(`rpa-template/export-excel?q=${query || ''}`)
        } catch (error) {
            console.error('Export API text error:', error);
            throw error;
        }
    },

    async exportExcelCSV(query_rpa) {
        try {
            // Use the new export-excel-csv endpoint
            return await axios.get(`rpa-template/export-excel-csv?q=${query_rpa || ''}`)
        } catch (error) {
            console.error('Export CSV API error:', error);
            throw error;
        }
    },

    async import(formData) {
        try {
            return await axios.post('rpa-template/import', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
                timeout: 60000,
                validateStatus: status => status < 500
            });
        } catch (error) {
            console.error('Import API error:', error);
            throw error;
        }
    },

    async validateImportFile(formData) {
        try {
            return await axios.post('rpa-template/validate-import', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        } catch (error) {
            console.error('Import validation error:', error);
            throw error;
        }
    }
} 